export const messages = {
    notBuilt: { message: "This page is not built yet !! ", icon: 'settings_outlined' },
    empty: { message: "No data available", icon: 'assignment_late' },
    notFound: { message: "This page is not found 404", icon: 'report_problem_outlined' },
    unAuthorized: { message: "Un Authorized 400", icon: 'lock_outlined' },
}